<template>
  <div id="plans" class="f-c-s f-d-c w-100 h-100 o-f-a">
    <div
      v-if="catStep === 2"
      id="package"
      class="packages f-c-s f-d-c w-100 h-100"
    >
      <h4 class="mb-5">انتخاب بسته‌ها</h4>
      <div class="packageList w-100 f-c-sa f-w-w">
        <div
          v-for="(v, i) in packageList"
          :key="i"
          class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xs-12"
        >
          <div class="package" :class="[v.id == 5 || v.id == 8 ? 'more' : '']">
            <b-card
              border-variant="info"
              :header="v.title"
              header-bg-variant="info"
              header-text-variant="white"
              align="center"
            >
              <b-card-text>
                <b-button variant="info" @click.stop="optionShow(v)"
                  >خرید بسته</b-button
                >
                <button
                  v-if="v.id == 5 || v.id == 8"
                  @click="packageDetails(v)"
                  type="button"
                  class="btn"
                >
                  اطلاعات بیشتر
                </button>
                <!-- <button @click.stop="optionShow(v)" type="button" class="btn">
                خرید بسته
              </button> -->
              </b-card-text>
            </b-card>
            <div class="package-period-select" v-if="optionsListId == v.id">
              <h4></h4>
              <div class="clearfix period-packages">
                <div
                  v-for="(b, j) in v.options"
                  :key="j"
                  class="package-periods-item"
                  @click="selectPackage(v, b)"
                >
                  <span class="period-item">{{ b.offered_value }}</span>
                  <span class="period-price">{{ b.price }}</span>
                </div>
              </div>
            </div>
            <div v-if="packagesSelect.length" class="package-select-list f-c-s">
              <div v-for="(p, l) in packagesSelect" :key="l">
                <div v-if="p.parentId == v.id">
                  {{ p.title
                  }}<span @click="deletePackage(v)" class="delete">x</span>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="package">
            <h3 class="title">
              <img :src="v.img" />
              <span>{{ v.title }}</span>
            </h3>
            <div class="buttons">
              <button @click.stop="optionShow(v)" type="button" class="btn">
                خرید بسته
              </button>
            </div>
            <div v-if="packagesSelect.length" class="package-select-list f-c-s">
              <div v-for="(p, l) in packagesSelect" :key="l">
                <div v-if="p.parentId == v.id">
                  {{ p.title
                  }}<span @click="deletePackage(v)" class="delete">x</span>
                </div>
              </div>
            </div>
            <div class="package-period-select" v-if="optionsListId == v.id">
              <h4>دوره پرداخت</h4>
              <div class="clearfix period-packages">
                <div
                  v-for="(b, j) in v.options"
                  :key="j"
                  class="package-periods-item"
                  @click="selectPackage(v, b)"
                >
                  <span class="period-item">{{ b.offered_value }}</span>
                  <span class="period-price">{{ b.price }}</span>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="return w-100 f-c-e">
        <div class="btnSec f-c-c">
          <b-button @click="returnStep()" variant="outline-primary" class="ml-2"
            >بازگشت</b-button
          >
          <button
            @click="!isBuy && packagesSelect.length ? finalPayment() : ''"
            class="btn btn-primary btn-block"
            :class="[!isBuy && packagesSelect.length ? '' : 'disabled']"
          >
            تایید و ادامه
          </button>
        </div>
      </div>
    </div>
    <div v-if="catStep === 3" class="step3 w-100 h-100 f-s-s f-d-c mb-5 mt-5">
      <div class="w-full px-5">
        <div>
          <h6 class="f-c-c">مشخصات سفارش</h6>
          <!-- <table class="w-full" style="direction: rtl">
            <tbody>
              <tr class="info-item">
                <td>{{ "تعداد کاربر همزمان" }}</td>
                <td>{{ plan.max_user_count + " نفر " }}</td>
              </tr>
            </tbody>
          </table> -->
        </div>
        <div class="mt-6">
          <div>
            <h6 class="t-title">هزینه‌ها</h6>
            <table class="w-full price-table" style="direction: rtl">
              <thead>
                <tr>
                  <td>عنوان</td>
                  <td>قیمت</td>
                  <!-- <td>تعداد</td>
                  <td>مجموع</td> -->
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(info, i) in planTansaction.factor_items"
                  class="info-item"
                  :key="i"
                >
                  <td>{{ info.title }}</td>
                  <td>{{ info.price + " تومان " }}</td>
                  <!-- <td>{{ info.count }}</td>
                  <td>{{ info.totalPrice }}</td> -->
                </tr>
              </tbody>
            </table>
          </div>
          <div class="mt-3">
            <table class="w-full" style="direction: rtl">
              <tbody>
                <tr class="info-item">
                  <td>جمع کل</td>
                  <td>{{ planTansaction.total_price + " تومان " }}</td>
                </tr>
                <tr class="info-item">
                  <td>تخفیف</td>
                  <td>
                    {{
                      planTansaction.off_price
                        ? planTansaction.off_price + " تومان "
                        : 0
                    }}
                  </td>
                </tr>
                <tr class="info-item">
                  <td>مبلغ قابل پرداخت</td>
                  <td>{{ planTansaction.payable_price + " تومان " }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <hr />
        <div class="voucherSec flex items-center justify-between w-full gap-2">
          <div class="flex items-center">
            <!-- <label class="alert flex items-center" for="acceptRoles">
              <input v-model="role" type="checkbox" name="acceptRoles" id="acceptRoles" />
              <div>
                <a href="#"> قوانین و شرایط استفاده از واداروم</a>
                را خوانده و می‌پذیرم.
              </div>
            </label> -->
            <div class="voucher f-c-s">
              <input
                type="text"
                class="ml-3"
                v-model="voucher"
                placeholder="کد تخفیف"
              />
              <b-button variant="outline-secondary" @click="voucherFunc"
                >ثبت</b-button
              >
              <!-- <button class="f-c-c btn btn-primary" @click="voucherFunc">
                ثبت
              </button> -->
            </div>
          </div>
          <div class="return w-100 f-c-e">
            <div class="btnSec f-c-c">
              <b-button
                @click="returnStep2()"
                variant="outline-primary"
                class="ml-2"
                >بازگشت</b-button
              >
              <button
                @click="!isBuy ? finalPayment2() : ''"
                class="btn btn-primary btn-block"
                :class="[!isBuy ? '' : 'disabled']"
              >
                پرداخت
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="edit-modal"
      title="توجه"
      button-size="sm"
      size="lg"
      :hide-footer="footer"
      ref="help-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <h4 class="f-c-c">{{ helpTitle }}</h4>
        <div class="text f_c_c w-100 mb-5 mt-4">
          {{ helpContent }}
        </div>
        <div class="btnSection w-100 f-c-c">
          <div class="btnItem1 f_c_c ml-2" @click="helpunderstood()">
            {{ "تایید" }}
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "Packages",
  data() {
    return {
      packageList: [],
      packagesSelect: [],
      package: null,
      optionsListId: null,
      isBuy: false,
      catStep: 2,
      voucher: "",
      helpTitle: "",
      helpContent: "",
      footer: true,
    };
  },
  created() {
    this.getAllPackageFunction({ user_id: this.user.user_id });
  },
  computed: {
    ...mapState({
      user: (state) => state.gap.user,
      allPackage: (state) => state.gap.allPackage,
      organSelectForBuyPelan: (state) => state.gap.organSelectForBuyPelan,
      buyPackagesResult: (state) => state.gap.buyPackagesResult,
      planTansaction: (state) => state.gap.planTansaction,
      voucherData: (state) => state.gap.voucherData,
    }),
  },
  methods: {
    ...mapActions("gap", [
      "getAllPackageFunction",
      "getPlanTansactionFunction",
      "finalPaymentPackagesFunction",
      "setVoucherFunction",
    ]),
    packageDetails(v) {
      if (v.id == 5) {
        this.helpTitle = "پشتیبانی ویژه حضوری";
        this.helpContent =
          "لطفا برای پشتیبانی حضوری جلسات بیش از 500 نفر با شماره پشتیبانی تماس حاصل فرمایید.";
      } else {
        this.helpTitle = "پشتیبانی ویژه آنلاین";
        this.helpContent =
          "لطفا برای پشتیبانی آنلاین ویژه جلسات بیش از 500 نفر با شماره پشتیبانی تماس حاصل فرمایید.";
      }
      this.$refs["help-modal"].show();
    },
    helpunderstood() {
      this.$refs["help-modal"].hide();
    },
    voucherFunc() {
      if (this.voucher.trim()) {
        this.setVoucherFunction({
          user_id: this.user.user_id,
          transaction_id: this.buyPackagesResult.factor_id,
          voucher: this.voucher,
        });
      } else {
        this.$bvToast.toast("کد تخفیف وارد نشده است.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      }
    },
    finalPayment2() {
      this.isBuy = true;
      this.packagesSelect = [];
      this.optionsListId = 0;
      window.open(this.planTansaction.payment_url, "_blank");
      setTimeout(() => {
        this.setPlanOrderFunction({});
        this.catStep = 1;
      }, 100);
    },
    returnStep() {
      this.$router.back();
      if (
        document.querySelector(
          "#package .packageList .package .package-period-select"
        )
      ) {
        document.querySelector(
          "#package .packageList .package .package-period-select"
        ).style.display = "none";
      }
      this.optionsListId = 0;
    },
    returnStep2() {
      if (
        document.querySelector(
          "#package .packageList .package .package-period-select"
        )
      ) {
        document.querySelector(
          "#package .packageList .package .package-period-select"
        ).style.display = "none";
      }
      this.optionsListId = 0;
      this.catStep = 2;
    },
    finalPayment() {
      if (this.packagesSelect.length) {
        this.isBuy = true;
        if (
          document.querySelector(
            "#package .packageList .package .package-period-select"
          )
        ) {
          document.querySelector(
            "#package .packageList .package .package-period-select"
          ).style.display = "none";
        }
        this.catStep = 3;
        let obj = {};
        obj.type = "set/organ_recharge_package";
        obj.user_id = this.user.user_id;
        obj.organ_id =
          this.user.is_organ == "yes" ? this.organSelectForBuyPelan : 0;
        for (let i = 0; i < this.packagesSelect.length; i++) {
          Object.assign(obj, {
            [`organ_packages[${this.packagesSelect[i].key}]`]:
              this.packagesSelect[i].childId,
          });
        }
        this.finalPaymentPackagesFunction(obj);
        // this.optionsListId = 0;
        // let obj = {};
        // obj.type = "set/organ_recharge_package";
        // obj.user_id = this.user.user_id;
        // obj.organ_id = this.organSelectForBuyPelan;
        // for (let i = 0; i < this.packagesSelect.length; i++) {
        //   Object.assign(obj, {
        //     [`organ_packages[${this.packagesSelect[i].key}]`]:
        //       this.packagesSelect[i].childId,
        //   });
        // }
        // this.finalPaymentPackagesFunction(obj);
      }
    },
    deletePackage(v) {
      const pos = this.packagesSelect.map((e) => e.parentId).indexOf(v.id);
      this.packagesSelect.splice(pos, 1);
    },
    selectPackage(parent, option) {
      const pos = this.packagesSelect.map((e) => e.key).indexOf(parent.key);
      if (parseInt(pos) > -1) {
        this.packagesSelect.splice(pos, 1);
        this.packagesSelect.push({
          parentId: parent.id,
          childId: parseInt(option.id),
          key: parent.key,
          title: option.offered_value + " , " + option.price,
        });
      } else {
        this.packagesSelect.push({
          parentId: parent.id,
          childId: parseInt(option.id),
          key: parent.key,
          title: option.offered_value + " , " + option.price,
        });
      }
    },
    optionShow(v) {
      this.optionsListId = v.id;
      if (
        document.querySelector(
          "#package .packageList .package .package-period-select"
        )
      ) {
        document.querySelector(
          "#package .packageList .package .package-period-select"
        ).style.display = "block";
      }
    },
  },
  watch: {
    voucherData(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.voucher = "";
          this.$bvToast.toast(n.message, {
            title: "ثبت",
            variant: "success",
            solid: true,
          });
          this.getPlanTansactionFunction({
            user_id: this.user.user_id,
            transaction_id: this.buyPackagesResult.factor_id,
          });
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    allPackage(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          for (let x in n.subscription_packages) {
            n.subscription_packages[x].key = x;
          }
          this.packageList = n.subscription_packages;
        } else {
          this.packageList = [];
        }
      }
    },
    buyPackagesResult(n) {
      if (Object.keys(n).length) {
        this.isBuy = false;
        if (n.code == 100) {
          this.getPlanTansactionFunction({
            user_id: this.user.user_id,
            transaction_id: n.factor_id,
          });
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
  },
  mounted() {
    document.body.onclick = function (event) {
      if (!event.target.classList.contains("btn")) {
        if (
          document.querySelector(
            "#package .packageList .package .package-period-select"
          )
        ) {
          document.querySelector(
            "#package .packageList .package .package-period-select"
          ).style.display = "none";
        }
        this.optionsListId = 0;
      }
    };
  },
};
</script>
<style lang="scss">
.packages {
  margin-top: 5rem;
  .packageList {
    padding-bottom: 5rem;
    border-bottom: 1px solid #e6e9e9;
  }
  h4 {
    font-weight: 600;
  }
  .package {
    position: relative;
    color: #fff;
    padding: 0;
    background: transparent;
    text-align: center;
    margin-bottom: 25px;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    -webkit-box-shadow: 0 2px 6px #e2e2e2;
    -moz-box-shadow: 0 2px 6px #e2e2e2;
    box-shadow: 0 2px 6px #e2e2e2;
    .card-body {
      padding: 1.25rem 0;
    }
    .title {
      font-size: 1.2rem;
      font-weight: 700;
      text-align: center;
      margin-bottom: 15px;
      text-shadow: 0 2px 0 rgba(0, 0, 0, 0.2);
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 5px;
    }
    .btn {
      color: white;
      padding: 6px 0 5px;
      background: #17a2b8;
      border: none;
      min-width: 105px;
      line-height: normal;
      transition: 0.3s;
      -webkit-box-shadow: 0 2px 11px rgba(0, 0, 0, 0.2);
      -moz-box-shadow: 0 2px 11px rgba(0, 0, 0, 0.2);
      box-shadow: 0 2px 11px rgba(0, 0, 0, 0.2);
      &:first-child {
        margin-left: 5px;
      }
      &:hover {
        min-width: 130px;
        background: #17a2b8;
        -webkit-box-shadow: 0 4px 18px #17a2b8;
        -moz-box-shadow: 0 4px 18px #17a2b8;
        box-shadow: 0 4px 18px #17a2b8;
      }
    }
    .package-select-list {
      width: 100%;
      position: absolute;
      bottom: -25px;
      color: black;
      right: 0.5rem;
      font-size: 0.8rem;
      .delete {
        color: red;
        margin: 0 0.5rem;
        cursor: pointer;
      }
    }
    .package-period-select {
      width: 100%;
      position: absolute;
      top: 100%;
      left: 0;
      background: #dbedff;
      margin-top: 13px;
      padding-top: 10px;
      border: 1px solid #efefef;
      z-index: 99999;
      -webkit-border-radius: 2px;
      -moz-border-radius: 2px;
      border-radius: 2px;
      -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
      -moz-box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
      h4 {
        font-weight: 700;
        font-size: 0.9rem;
        color: #3b3b3b;
        margin-bottom: 20px;
        text-align: center;
      }
      .period-packages {
        display: flex;
        justify-content: center;
        flex-direction: column;
        gap: 20px;
        .package-periods-item {
          display: flex;
          font-size: 0.8rem;
          color: #3b3b3b !important;
          cursor: pointer;
          justify-content: space-around;
          &:hover {
            color: #1493d4 !important;
          }
          .period-item {
            width: 40%;
          }
          .period-price {
            width: 60%;
          }
        }
      }
      &::after {
        content: "";
        position: absolute;
        top: -14px;
        left: 50%;
        margin-left: -15px;
        border-bottom: 15px solid #dbedff;
        border-right: 15px solid transparent;
        border-left: 15px solid transparent;
      }
    }
  }
  .more {
    .btn {
      min-width: 105px;
      &:hover {
        min-width: 105px;
      }
    }
  }
  .return {
    padding: 15px;
    .btnSec {
      .disabled {
        cursor: no-drop;
      }
    }
  }
}
.step3 {
  .voucher {
    input {
      position: relative;
      background: #ffffff;
      border-radius: 4px;
      border: 0;
      border-bottom: 1px solid #125488;
      color: #3f3f3f;
      padding: 0.35rem;
      padding-right: 0.5rem;
      letter-spacing: 1px;
      font-size: 80%;
      &:focus {
        outline: none;
      }
      &:focus-visible {
        outline: none;
      }
    }
  }
  .w-full {
    width: 100%;
  }
  .w-fit {
    width: fit-content;
  }
  .min-w-fit {
    min-width: fit-content;
  }
  .h-fit {
    height: fit-content;
  }
  .flex {
    display: flex;
  }
  .items-center {
    align-items: center;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-between {
    justify-content: space-between;
  }
  .flex-1 {
    flex: 1;
  }
  .flex-col {
    flex-direction: column;
  }
  .flex-row {
    flex-direction: row;
  }
  .flex-col-reverse {
    flex-direction: column-reverse;
  }
  .flex-row-reverse {
    flex-direction: row-reverse;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .px-1 {
    padding-right: 4px;
    padding-left: 4px;
  }
  .px-2 {
    padding-right: 8px;
    padding-left: 8px;
  }
  .px-3 {
    padding-right: 12px;
    padding-left: 12px;
  }
  .mt-3 {
    margin-top: 12px;
  }
  .mt-6 {
    margin-top: 24px;
  }
  .gap-1 {
    gap: 4px;
  }
  .gap-2 {
    gap: 8px;
  }
  .gap-3 {
    gap: 12px;
  }
  .gap-4 {
    gap: 16px;
  }
  h6 {
    font-size: 1.3rem;
    font-weight: bold;
  }
  h6.t-title {
    font-size: 14px;
  }

  table {
    * {
      direction: rtl;
      text-align: right;
    }
    caption {
      font-size: 14px;
      font-weight: 600;
      color: #3b3b3b;
      top: 0;
    }
    tbody {
      border: 1px solid #ccc;
      tr {
        border-top: 1px solid #ccc;
        &:first-child {
          border-top: unset;
        }
        &:nth-child(odd) {
          background-color: #eeeeee;
        }
        &:nth-child(even) {
          background-color: #f7f7f7;
        }
        td {
          padding: 6px 10px;
          font-size: 12px;
          &:first-child {
            width: 36%;
            border-left: 1px solid #ccc;
          }
        }
      }
    }
    &.price-table {
      thead {
        width: 100%;
        border: 1px solid #ccc;
        border-bottom: unset;
        tr {
          display: flex;
          font-weight: 500;
          font-size: 12px;
          padding: unset;
          td {
            padding: 6px 10px;
            flex: 1;
            border-left: 1px solid #ccc;
            &:last-child {
              border-left: unset;
            }
          }
        }
      }
      tbody {
        tr {
          display: flex;
          td {
            flex: 1;
            border-left: 1px solid #ccc;
            &:last-child {
              border-left: unset;
            }
          }
        }
      }
    }
  }
  .alert {
    gap: 8px;
    font-size: 12px;
    background-color: #f5c02f3d;
    width: fit-content;
    border-radius: 6px;
    border: 1px solid #f5c02f6b;
    margin: unset;
    a {
      color: #0898d2;
    }
    label {
    }
  }
}
</style>